import { Decoration } from './Decoration';

export const Decorations = ({ decorations }) => (
  <div className="overflow-hidden absolute inset-0">
    {decorations?.map((decoration) => (
      <Decoration {...decoration} key={JSON.stringify(decoration)} />
    ))}
  </div>
);
